import type { Pog } from "@CommonTypes/merchflow/pog/pog";
import type { FrontOverhangViolation } from "@CommonUtils/pog/frontOverhang";
import { usableShelfDepth } from "@CommonUtils/pog/shelfLoader";
import { translate } from "src/i18n/translate";

export const frontOverhangViolationText = (pog: Pog, violation: FrontOverhangViolation) => {
  const shelf = pog.getShelf(violation.shelfId);
  const item = shelf?.items.find((candidate) => candidate.uniqueId === violation.itemId);
  if (!shelf || !item)
    return translate("common", "frontOverhang.violationFallback", {
      product: violation.productCode,
      shelf: violation.shelfId,
    });

  return translate("common", "frontOverhang.violation", {
    product: item.name || item.productCode,
    shelf: `${shelf.bay.getNo()}.${shelf.getNo()}`,
    excess: (Math.max(0, item.getDepth() - usableShelfDepth(shelf)) / 100).toFixed(2),
    allowance: ((shelf.maxFrontOverhang ?? 0) / 100).toFixed(2),
  });
};
